import React from "react";
import { connect } from "react-redux";
import {
  Transition,
  Container,
  Segment,
  Header,
  Button
} from "semantic-ui-react";
import { confirmadasOps } from "../ducks/confirmadas";
import TablaInscripciones from "./inscripcionesConfirmadas/TablaInscripciones";

class InscripcionesConfirmadas extends React.Component {
  state = {
    visible: false,
    totalInscripciones: this.props.datos.reduce(
      (anterior, actual) => anterior + actual.num,
      0
    )
  };

  componentDidMount() {
    this.setState({ visible: true });
    this.props.obtenerInscripcionesPorColegio();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      totalInscripciones: nextProps.datos.reduce(
        (anterior, actual) => anterior + actual.num,
        0
      )
    };
  }

  componentWillUnmount() {
    this.props.limpiarInscripcionesPorColegio();
  }

  handleVolver = () => this.props.history.goBack();

  render() {
    return (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible && (
          <Container>
            <Segment basic>
              <Button
                content="Cerrar"
                floated="right"
                color="pink"
                icon="cancel"
                onClick={this.handleVolver}
              />

              <Header inverted as="h2">
                Inscripciones Confirmadas: {this.state.totalInscripciones}
              </Header>
            </Segment>
            <TablaInscripciones
              datos={this.props.datos}
              total={this.state.totalInscripciones}
            />
          </Container>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  datos: state.confirmadas.inscripcionesPorColegio
});

const mapDispatchToProps = {
  obtenerInscripcionesPorColegio: confirmadasOps.obtenerInscripcionesPorColegio,
  limpiarInscripcionesPorColegio: confirmadasOps.limpiarInscripcionesPorColegio
};

export default connect(mapStateToProps, mapDispatchToProps)(
  InscripcionesConfirmadas
);



// WEBPACK FOOTER //
// ./src/pages/InscripcionesConfirmadas.jsx